import { Component, OnInit } from '@angular/core';
import { ApiService } from './services/api.service';
import CookieMonster from '@firstandthird/cookie-monster';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { RoleSelectionComponent } from 'src/app/shared/components/role-selection/role-selection.component';
import { ModalController } from '@ionic/angular';
import { SimrSwitchAccountService } from './services/simr-switch-account.service';
import {
  captureSimrPostRoleRedirect,
  consumeSimrPostRoleRedirect,
  getSimrPostRoleRedirect,
  getSimrSessionPrimaryUserId,
  isSimrRoleSelectionHandled,
  markSimrRoleSelectionHandled,
  onSimrLoginPrimaryUser,
  resolveSimrPrimaryUserId,
} from './utils/simr-role-selection';
import {
  canAccessBulkUpload,
  canAccessBulkUpdate,
  resolvePulseRoleName,
} from './utils/bulk-upload-access';
import { canAccessBulkApprovalFromLocalStorage } from './utils/bulk-approval-access';
import { hasPreReviewAccess } from './utils/pre-review-role-access';
import { deriveTipsVideoPermissions } from './utils/tips-video-permissions';
import { fetchAllMasterPages, loadClassificationMaster, loadNamedMasters } from './utils/classification-masters';
import { normalizeMasterLabels } from './utils/master-labels';
import { requestPortalProductLogin } from './utils/portal-product-login';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  public appPages = [
    { title: 'Products', url: '/products', icon: 'musical-note-outline' },
    { title: 'Tracks', url: '/tracks', icon: 'pause-circle-outline' },
    { title: 'Release Calendar', url: '/release-calender', icon: 'calendar-number-outline' },
    // {title:'Partner Management', url:'/partner-view' , icon:'people-outline'}


  ];
  role: any;
  current_user: any;
  currentPermissions: any;
  currentRole: any;
  linkedAccounts: any[] = [];
  bulkMenuOpen = false;
  modalCtrl = inject(ModalController);
  private simrReapplyChecked = false;
  private roleSelectionModalPending = false;

  constructor(
    public apiService: ApiService,
    private cookieService: CookieService,
    private router: Router,
    private simrSwitchAccountService: SimrSwitchAccountService
  ) { }
  ngOnInit() {
    this.getSetAccessToken();
    let role = localStorage.getItem('role_detail');
    if (role) {
      this.role = JSON.parse(role);
      console.log(this.role);
    }
    let current_user = localStorage.getItem('current_user');

    if (current_user) {
      this.current_user = JSON.parse(current_user);
      // Role-wise permission change
      // (sidebar previously relied on `role` / `current_user` only; align with role-derived permissions)
      this.apiService.syncRoleDerivedStateFromCurrentUser(this.current_user);
      this.role = this.apiService.currentRole;
      this.currentRole = this.apiService.currentRole;
      this.currentPermissions = this.apiService.currentPermissions;

      console.log(this.current_user);
    }

    this.apiService.currentUser$.subscribe(user => {
      if (user) {
        this.current_user = user;
        // Role-wise permission change
        // this.role = user.role;
        // this.currentRole = user.role;
        // this.currentPermissions = user.role;
        this.apiService.syncRoleDerivedStateFromCurrentUser(user);
        this.role = this.apiService.currentRole;
        this.currentRole = this.apiService.currentRole;
        this.currentPermissions = this.apiService.currentPermissions;
        this.loadLinkedAccounts();
        if (!this.simrReapplyChecked) {
          this.simrReapplyChecked = true;
          this.simrSwitchAccountService.reapplyIfNeeded(this.apiService);
        }
      } else {
        this.linkedAccounts = [];
      }
    });

    if (this.current_user && !this.linkedAccounts?.length) {
      setTimeout(() => this.loadLinkedAccounts(), 1500);
    }
  }

  getSetAccessToken() {
    //let cookie_dst=CookieMonster.get('directus_session_token');
    //let cs2= this.cookieService.get('directus_session_token');
    //  console.log(cookie_dst,cs2);

    // if(cookie_dst){
    //  localStorage.setItem('access_token',cookie_dst);
    //}
    //if localStorage accessP_token set it
    let access_token = localStorage.getItem('access_token');
    if (access_token) {
      this.apiService.access_token = access_token;
    }

    //read access_token from URL as parameter
    let url = new URL(window.location.href);
    const urlAccessUserId = url.searchParams.get('access_user_id');
    const redirectParams = new URLSearchParams(url.search);
    redirectParams.delete('access_user_id');
    const redirectSearch = redirectParams.toString();
    captureSimrPostRoleRedirect(url.pathname, redirectSearch ? `?${redirectSearch}` : '');
    let access_user_id = urlAccessUserId || sessionStorage.getItem('access_user_id') || localStorage.getItem('access_user_id');
    //let access_user_id='f6ef752c-3376-40c3-8004-49ee008dd7a1';    // Andrea 
    //let access_user_id = '3767004e-d4cb-49ce-b677-2a8bf1ff611e';    // submit

    //let access_user_id = '3767004e-d4cb-49ce-b677-2a8bf1ff611e';    // submit

    // let access_user_id = '08b3bfa5-9459-4a2d-aed5-67dddd90994a';    // super Admin
    // let access_user_id = '55790dec-fc79-4131-a746-641fbb31897a';// legal

    // let access_user_id='41f4337f-c362-449c-881c-c13247b123a7';  //A&R
    // let access_user_id='08b3bfa5-9459-4a2d-ae
    // d5-67dddd90994a'//operation_edit
    // let access_user_id = '3767004e-d4cb-49ce-b677-2a8bf1ff611e';    // approver
    // let access_user_id = '41f4337f-c362-449c-881c-c13247b123a7'//marketing CH
    // let access_user_id = 'c2d5d8e5-d410-4045-ae6d-132fc7b4b046'//marketing BL
    //  let access_user_id='2656f881-d7a4-44b5-8741-69798984270b'// Pankaj BL
    // let access_user_id = '9461fa39-acc4-4d3b-ad24-6d54bc93c275'// super admin

    // let access_user_id = '55790dec-fc79-4131-a746-641fbb31897a'//legal
    if (access_user_id) {
      //this.apiService.access_token=access_user_id;
      localStorage.setItem('access_user_id', access_user_id);

      // New tab with an existing session: stay on the requested route (e.g. /products/:id).
      // An expired login token is renewed before the page calls the API. A valid token is left as it is.
      if (access_token && !urlAccessUserId) {
        if (this.apiService.accessTokenExpired()) {
          this.apiService.ensureAccessUserLogin(access_user_id).catch(() => undefined);
        }
        return;
      }

      console.log('[AppComponent] login with access_user_id', access_user_id);
      const searchParams = new URLSearchParams(url.search);
      searchParams.delete('access_user_id');
      const qs = searchParams.toString();
      const pathFallback =
        url.pathname && url.pathname !== '/' && url.pathname !== '/login'
          ? `${url.pathname}${qs ? `?${qs}` : ''}`
          : '/products';
      this.apiService.ensureAccessUserLogin(access_user_id).then((res: any) => {
        console.log('login', res);
        if (res && (res.access_token || localStorage.getItem('access_token'))) {
          this.router.navigateByUrl(pathFallback);
          this.getDatacache();
        }
      }).catch(() => undefined);
      return;
    } else {
      const refreshToken = (localStorage.getItem('refresh_token') || '').trim();
      // Logged-out email links are framed by the portal. Skip refresh and master loads
      // so the portal can open its own login page, then return to this product.
      if (!access_token && !refreshToken && requestPortalProductLogin()) {
        return;
      }
      this.apiService.refresh_token().subscribe((res: any) => {
        console.log('token refresh called');
      });

      // setInterval(() => {
      //   this.apiService.refresh_token().subscribe((res:any) =>{
      //     console.log('token refresh called');
      // });        
      // }, 40000);


      //this.getDatacache();
    }
    console.log('access_user_id', access_user_id);
    setTimeout(() => {
      this.getDatacache();

    }, 3000);


  }


  async getDatacache() {
    // let r = await this.apiService.get('genres', { limit: 200 });
    // if (r.data) {
    //   localStorage.setItem('genres', JSON.stringify(r.data));
    // }
    // let c = await this.apiService.get('contribution_roles');
    // localStorage.setItem('contribution_roles', JSON.stringify(c.data));
    // let l = await this.apiService.get('languages', { limit: 500 });
    // localStorage.setItem('languages', JSON.stringify(l.data));
    // let tags = await this.apiService.get('tags_keywords');
    // localStorage.setItem('tags_keywords', JSON.stringify(tags.data));
    // let s_ver = await this.apiService.get('versions');
    // localStorage.setItem('versions', JSON.stringify(s_ver.data));
    // let societies = await this.apiService.get('societies');
    // let mo = await this.apiService.get('moods');
    // localStorage.setItem('moods', JSON.stringify(mo.data));
    // let th = await this.apiService.get('themes');
    // localStorage.setItem('themes', JSON.stringify(th.data));
    // let chan=  await this.apiService.get('channels');
    // localStorage.setItem('channels',JSON.stringify(chan.data));

    // Each list is independent. A failure on Occasion must not skip Deity, Relationship, or A&R.
    await Promise.all([
      loadNamedMasters(this.apiService),
      loadClassificationMaster(this.apiService, 'events', 'events', 'id,name'),
      loadClassificationMaster(this.apiService, 'deity', 'deity', 'id,name'),
      loadClassificationMaster(this.apiService, 'relationships', 'relationships', 'id,name'),
      loadClassificationMaster(this.apiService, 'a_r_managers', 'a_r_managers', 'id,name,email'),
    ]);

    /** Master labels (Original Label / `acquired_label` dropdown). Only `published` rows. */
    try {
      const labelRows = await fetchAllMasterPages(this.apiService, 'labels', {
        filter: { status: { _eq: 'published' } },
        sort: 'name',
        fields: 'id,name,title,label,status',
      });
      localStorage.setItem('labels', JSON.stringify(normalizeMasterLabels(labelRows)));
    } catch (e) {
      console.warn('[AppComponent] labels master load failed (Original Label dropdown may be empty until fixed)', e);
      if (localStorage.getItem('labels') == null) {
        localStorage.setItem('labels', '[]');
      }
    }
  }

  get canAccessBulkMenu(): boolean {
    const p = this.currentPermissions || {};
    const isTruthy = (v: any) => v === true || v === 1 || String(v).trim().toLowerCase() === 'true';

    const insert = isTruthy(p.is_bulk_insert_visible);
    const history = isTruthy(p.is_bulk_history_visible);
    const update = isTruthy(p.is_bulk_update_visible);
    const approvalHistory = isTruthy(p.is_bulk_approval_history_visible);
    const preBulkHistory = this.canAccessPreBulkApprovalMenu;

    // Backward compatibility: if flags are missing, fall back to old role-name behavior.
    if ([insert, history, update, approvalHistory].every(b => b === false) && !preBulkHistory) {
      const fromUser = String(this.current_user?.role?.name || this.role?.name || '').trim();
      const roleName = fromUser || resolvePulseRoleName();
      return canAccessBulkUpload(roleName);
    }

    return insert || history || update || approvalHistory || preBulkHistory;
  }

  get canAccessBulkInsertMenu(): boolean {
    const p = this.currentPermissions || {};
    const v = p.is_bulk_insert_visible;
    if (v == null) {
      const fromUser = String(this.current_user?.role?.name || this.role?.name || '').trim();
      const roleName = fromUser || resolvePulseRoleName();
      return canAccessBulkUpload(roleName);
    }
    return v === true || v === 1 || String(v).trim().toLowerCase() === 'true';
  }

  get canAccessBulkHistoryMenu(): boolean {
    const p = this.currentPermissions || {};
    const v = p.is_bulk_history_visible;
    if (v == null) {
      const fromUser = String(this.current_user?.role?.name || this.role?.name || '').trim();
      const roleName = fromUser || resolvePulseRoleName();
      return canAccessBulkUpload(roleName);
    }
    return v === true || v === 1 || String(v).trim().toLowerCase() === 'true';
  }

  get canAccessBulkUpdateMenu(): boolean {
    const p = this.currentPermissions || {};
    const v = p.is_bulk_update_visible;
    if (v == null) {
      const fromUser = String(this.current_user?.role?.name || this.role?.name || '').trim();
      const roleName = fromUser || resolvePulseRoleName();
      return canAccessBulkUpdate(roleName);
    }
    return v === true || v === 1 || String(v).trim().toLowerCase() === 'true';
  }

  get canAccessBulkApprovalMenu(): boolean {
    const p = this.currentPermissions || {};
    const v = p.is_bulk_approval_history_visible;
    if (v == null) return canAccessBulkApprovalFromLocalStorage();
    return v === true || v === 1 || String(v).trim().toLowerCase() === 'true';
  }

  get canAccessPreBulkApprovalMenu(): boolean {
    const p = this.currentPermissions || this.role || {};
    const v = p.is_pre_bulk_approval_history_visible;
    if (v == null) return hasPreReviewAccess(p) || hasPreReviewAccess(this.role);
    return v === true || v === 1 || String(v).trim().toLowerCase() === 'true';
  }
  get canAccessTipsVideoLibrary(): boolean {
    return deriveTipsVideoPermissions(this.currentPermissions || this.role || {}).canViewLibrary;
  }

  toggleBulkMenu() {
    this.bulkMenuOpen = !this.bulkMenuOpen;
  }

  async loadLinkedAccounts() {
    if (this.current_user) {
      const accounts = await this.apiService.getLinkedAccounts();
      const activeAccounts = (accounts || []).filter((acc: any) => {
        return (acc?.status || '').toLowerCase() === 'active';
      });
      if (!activeAccounts.length && this.linkedAccounts.length) {
        return;
      }
      this.linkedAccounts = activeAccounts;
      console.log('[AppComponent] linkedAccounts', this.linkedAccounts);

      const primaryUserId = resolveSimrPrimaryUserId(this.current_user, this.linkedAccounts);
      if (primaryUserId && getSimrSessionPrimaryUserId() !== primaryUserId) {
        onSimrLoginPrimaryUser(primaryUserId);
      }

      const handled = isSimrRoleSelectionHandled(primaryUserId);
      if (this.linkedAccounts?.length > 1 && !handled && !this.roleSelectionModalPending) {
        this.roleSelectionModalPending = true;
        const snapshot = this.linkedAccounts.slice();
        setTimeout(() => this.openRoleSelectionModal(snapshot), 1500);
      }
    }
  }

  async openRoleSelectionModal(accounts?: any[]) {
    try {
      captureSimrPostRoleRedirect();
      const dirtyElement = document.querySelector('.ng-dirty, .ion-dirty, [class*="dirty"], .ng-select.ng-dirty, form.ng-dirty');
      if (dirtyElement) {
        console.log('[AppComponent] Form is dirty, found element:', dirtyElement);
        const confirmed = await this.apiService.presentAlertConfirm(
          'Unsaved Changes',
          'You have unsaved changes. Switching accounts will refresh the page and you may lose your progress. Continue?',
          'Yes, Switch',
          'Stay Here'
        );
        if (confirmed) return;
      }

      let source = accounts?.length ? accounts : this.linkedAccounts;
      if (!source?.length) {
        const fetched = await this.apiService.getLinkedAccounts();
        source = (fetched || []).filter((acc: any) => (acc?.status || '').toLowerCase() === 'active');
        if (source.length) {
          this.linkedAccounts = source;
        }
      }
      console.log('[AppComponent] openRoleSelectionModal with linkedAccounts', source);

      const rolesForModal = (source || []).map((acc: any) => ({
        id: acc.id,
        name: acc.role?.name || acc.role_name || 'User',
        description: acc.email,
        icon: acc.is_parent ? 'star-outline' : 'person-outline',
        is_parent: acc.is_parent,
      }));
      if (!rolesForModal.length) {
        return;
      }

      const modal = await this.modalCtrl.create({
        component: RoleSelectionComponent,
        componentProps: {
          roles: rolesForModal,
          currentRoleId: this.current_user?.id
        },
        backdropDismiss: false,
        cssClass: 'role-selection-modal'
      });

      await modal.present();

      const { data } = await modal.onWillDismiss();
      if (data) {
        console.log('[AppComponent] Selected account to switch:', data);
        const primaryUserId = resolveSimrPrimaryUserId(this.current_user, this.linkedAccounts);
        markSimrRoleSelectionHandled(primaryUserId);
        await this.apiService.switchAccount(data.id);
        setTimeout(() => {
          window.location.href = consumeSimrPostRoleRedirect('/products');
        }, 500);
      }
    } finally {
      this.roleSelectionModalPending = false;
    }
  }
}